<template>
  <v-container class="custom-container">
    <img class="gear-image" src="/media/handShake.png" />
    <div class="gear"></div>
    <!-- <div class="water"></div>-->
    <h1 class="gear-text">لطفا صبر کنید در حال انتقال به صفحه اصلی...</h1>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Callback',
  methods: {
    ...mapActions('oidc', ['oidcSignInCallback', 'getOidcUser', 'signOutOidc']),
    oidCheck() {
      let app = this;
      this.oidcSignInCallback()
        .then((redirectPath) => {
          setTimeout(() => {
            if (app.$store.getters.authorize == 'registration') {
              app.$router.push('/business-registration');
            } else if (app.$store.getters.authorize == 'merchant') {
              app.$router.push('/business-information');
            } else if (app.$store.getters.authorize == 'supplier') {
              app.$router.push('/dashboard');
            } else {
              app.$router.push(redirectPath);
            }
          }, 2000);
        })
        .catch((error) => {
          // this.signOutOidc();
          console.error(error);
          this.$router.push('/dashboard'); // Handle errors any way you want
        });
    },
  },
  computed: {
    ...mapGetters('oidc', [
      'oidcIsAuthenticated',
      'oidcAuthenticationIsChecked',
      'oidcUser',
      'oidcIdToken',
      'oidcIdTokenExp',
    ]),
  },
  mounted() {
    let app = this;
    this.getOidcUser().then((data) => {
      const now = new Date().getTime();
      app.oidCheck();
      // if (data == null) {
      //   app.oidCheck();
      // } else if (now > data.expires_at * 1000) {
      //   app.oidCheck();
      // }
    });
  },
};
</script>
<style scoped>
.gear {
  height: 250px;
  width: 250px;
  background: transparent;
  box-shadow: inset 0 0 0px 35px #808080, inset 0 0 0px 40px #808080;
  border-radius: 50%;
  position: relative;
  margin: 20px auto;
  -webkit-animation: rotate 5s linear infinite;
  -moz-animation: rotate 5s linear infinite;
  animation: rotate 5s linear infinite;
}
.gear:before,
.gear:after {
  height: 60px;
  width: 60px;
  content: '';
  border-radius: 20%;
  position: absolute;
  background: #808080;
}
.gear:before {
  box-shadow: 125px 125px 0 0 #808080, -125px 125px 0 0 #808080,
    0 250px 0 0 #808080;
  top: -30px;
  left: 90px;
}
.gear:after {
  transform: rotate(45deg);
  top: 5px;
  left: 185px;
  box-shadow: 0px 250px 0 0 #808080, 125px 125px 0 0 #808080,
    -125px 125px 0 0 #808080;
}
.gear-image {
  position: absolute;
  width: 190px;
  border-radius: 50%;
  height: 180px;
}

.custom-container {
  width: 100%;
  height: 100vh;
  background-color: #eef0f8;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gear-text {
  position: absolute;
  color: #666666;
  top: 80vh;
}
/*Keyframes*/
@-webkit-keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(-360deg);
  }
}
@-moz-keyframes rotate {
  0% {
    -moz-transform: rotate(0deg);
  }
  100% {
    -moz-transform: rotate(-360deg);
  }
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
@-webkit-keyframes rotate2 {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@-moz-keyframes rotate2 {
  0% {
    -moz-transform: rotate(0deg);
  }
  100% {
    -moz-transform: rotate(360deg);
  }
}
@keyframes rotate2 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
